import { ClassicPreset, GetSchemes, NodeEditor } from 'rete';
import { AngularArea2D } from 'rete-angular-plugin/15';
import { AreaPlugin } from 'rete-area-plugin';
import { ContextMenuExtra } from 'rete-context-menu-plugin';
import { DockPlugin } from '../drag&drop/dock-plugin';
import { Workflow } from './workflow';

type Schemes = GetSchemes<ClassicPreset.Node, ClassicPreset.Connection<ClassicPreset.Node, ClassicPreset.Node>>;
type AreaExtra = AngularArea2D<Schemes> | ContextMenuExtra;

/**
 * Represente le contexte d'affichage d'un workflow dans le designer.
 */
export class ReteContext {
    /**
     * Instance de l'editeur.
     */
    editor: NodeEditor<Schemes>;

    /**
     * Reference au plugin en charge du zoom, du drag&drop et de la selection.
     */
    area: AreaPlugin<Schemes, AreaExtra>;

    /**
     * Reference au plugin affichant les boutons pour ajouter des noeuds.
     */
    dock: DockPlugin<Schemes>;

    /**
     * Instance du workflow affiché dans le designer.
     */
    workflow: Workflow;
}
